<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách Website</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/dashboard">Dashboard</a></li>
              <li class="breadcrumb-item active">Website</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_website_modal">
              <i class="fa fa-plus"></i> Thêm Website
            </a>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped custom-table mb-0 datatable">
            <thead>
              <tr>
                <th>Tên Website</th>
                <th>Link</th>
                <th>Trạng thái</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="site in websites" :key="site.id">
                <td>{{ site.name }}</td>
                <td><a :href="site.baseUrl" target="_blank">{{ site.baseUrl }}</a></td>
                <td>
                  <span
                    :class="{
                      'badge bg-inverse-success': site.active,
                      'badge bg-inverse-danger': !site.active
                    }"
                  >
                    {{ site.active ? "Đang hoạt động" : "Không hoạt động" }}
                  </span>
                </td>
                <td class="text-right">
                  <div class="dropdown dropdown-action">
                    <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown">
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="#" data-toggle="modal" data-target="#edit_website_modal"
                        @click="editWebsite(site)">
                        <i class="fa fa-pencil m-r-5"></i> Sửa
                      </a>
                      <a class="dropdown-item" href="#" data-toggle="modal" data-target="#delete_website_modal"
                        @click="confirmDelete(site.id)">
                        <i class="fa fa-trash-o m-r-5"></i> Xóa
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="websites.length === 0 && !loading">
                <td colspan="4" class="text-center">Không có website nào</td>
              </tr>
              <tr v-if="loading">
                <td colspan="4" class="text-center">Đang tải...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-3">
        <div class="col-sm-12 col-md-5">
          <div>
            Hiển thị {{ currentPage * pageSize + 1 }} đến
            {{ Math.min((currentPage + 1) * pageSize, totalElements) }} của {{ totalElements }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <ul class="pagination justify-content-end">
            <li class="page-item" :class="{ disabled: currentPage === 0 }">
              <a href="#" class="page-link" @click.prevent="goToPage(currentPage - 1)">Previous</a>
            </li>
            <li class="page-item" v-for="pageNum in totalPages" :key="pageNum"
                :class="{ active: pageNum - 1 === currentPage }">
              <a href="#" class="page-link" @click.prevent="goToPage(pageNum - 1)">{{ pageNum }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages - 1 }">
              <a href="#" class="page-link" @click.prevent="goToPage(currentPage + 1)">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal: Add -->
    <div id="add_website_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="addWebsite">
            <div class="modal-header">
              <h5 class="modal-title">Thêm Website</h5>
              <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Tên website</label>
                <input v-model="newWebsite.name" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Base URL</label>
                <input v-model="newWebsite.baseUrl" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Username</label>
                <input v-model="newWebsite.wpUsername" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Password</label>
                <input v-model="newWebsite.wpAppPass" type="password" class="form-control" required />
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary">Thêm</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal: Edit -->
    <div id="edit_website_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="updateWebsite">
            <div class="modal-header">
              <h5 class="modal-title">Sửa Website</h5>
              <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Tên website</label>
                <input v-model="currentWebsite.name" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Base URL</label>
                <input v-model="currentWebsite.baseUrl" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Username</label>
                <input v-model="currentWebsite.wpUsername" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Password (nhập nếu muốn đổi)</label>
                <input v-model="currentWebsite.wpAppPass" type="password" class="form-control" />
              </div>
              <div class="form-group">
                <label>Trạng thái</label>
                <select v-model="currentWebsite.active" class="form-control">
                  <option :value="true">Đang hoạt động</option>
                  <option :value="false">Không hoạt động</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary">Lưu</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal: Delete -->
    <div id="delete_website_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <h4>Bạn có chắc chắn muốn xóa website này?</h4>
            <div class="d-flex justify-content-between mt-3">
              <button class="btn btn-danger" @click="deleteWebsite">Xóa</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useToast } from "vue-toastification";
import api from "../api";

const toast = useToast();

// State
const websites = ref([]);
const loading = ref(true);
const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

const newWebsite = reactive({ name: "", baseUrl: "", wpUsername: "", wpAppPass: "" });
const currentWebsite = reactive({ id: null, name: "", baseUrl: "", wpUsername: "", wpAppPass: "", active: true });
const websiteToDeleteId = ref(null);

// API
const fetchWebsites = async () => {
  loading.value = true;
  try {
    const res = await api.get("/api/wp-sites", { params: { page: currentPage.value, size: pageSize.value } });
    const data = res.data;
    websites.value = data.content;
    totalElements.value = data.totalElements;
    totalPages.value = data.totalPages;
  } catch (err) {
    toast.error("Không thể tải danh sách website");
    console.error(err);
  } finally {
    loading.value = false;
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchWebsites();
  }
};

const addWebsite = async () => {
  try {
    await api.post("/api/wp-sites", newWebsite);
    toast.success("Thêm website thành công!");
    fetchWebsites();
    Object.assign(newWebsite, { name: "", baseUrl: "", wpUsername: "", wpAppPass: "" });
  } catch (err) {
    toast.error("Không thể thêm website");
    console.error(err);
  }
};

const editWebsite = (site) => {
  Object.assign(currentWebsite, { ...site, wpAppPass: "" });
};

const updateWebsite = async () => {
  try {
    const payload = { ...currentWebsite };
    if (!payload.wpAppPass) delete payload.wpAppPass;
    await api.put(`/api/wp-sites/${currentWebsite.id}`, payload);
    toast.success("Cập nhật website thành công!");
    fetchWebsites();
  } catch (err) {
    toast.error("Không thể cập nhật website");
    console.error(err);
  }
};

const confirmDelete = (id) => {
  websiteToDeleteId.value = id;
};

const deleteWebsite = async () => {
  try {
    await api.delete(`/api/wp-sites/${websiteToDeleteId.value}`);
    toast.success("Xóa website thành công!");
    fetchWebsites();
  } catch (err) {
    toast.error("Không thể xóa website");
    console.error(err);
  }
};

onMounted(fetchWebsites);
</script>
